module.exports = __webpack_public_path__ + "static/media/article-card-default.4f59959b.jpg";